import TPhoneBookDetail from './index.vue';

TPhoneBookDetail.install = app => {
  app.component(TPhoneBookDetail.name, TPhoneBookDetail);
};

export default TPhoneBookDetail;
